module.exports = __webpack_public_path__ + "images/register/step1-icon.9bea17a9.svg";